import { z } from 'zod';
/**
 * 공통 ID / 타임스탬프 / 페이지네이션 / 에러 스키마.
 *
 * 참고: 금액(`KrwAmount`)·멱등키(`IdempotencyKey`) 는 별도 파일로 분리됨
 * (각각 `./money.ts`, `./idempotency.ts` — Phase 1/Plan 01-01).
 * 도메인 스키마(Donation, User 등)는 기능 구현 시 이 파일과 자매 파일에 추가.
 */
export const uuidSchema = z.string().uuid();
/** ISO 8601 타임스탬프 */
export const isoTimestampSchema = z.string().datetime({ offset: true });
/** 페이지네이션 기본 파라미터 */
export const paginationSchema = z.object({
    cursor: z.string().optional(),
    limit: z.number().int().min(1).max(100).default(20),
});
/** API 공통 에러 형식 */
export const apiErrorSchema = z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
});
//# sourceMappingURL=common.js.map